var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('isHeader',{ref:"isHeader"}),_c('div',{ref:"scrollBox",staticStyle:{"height":"100vh","overflow-y":"auto","overflow-x":"hidden"}},[_c('commonTop',{attrs:{"info":{
        title: '生态招募',
        desc: '携手华信互联共创健康管理生态社区',
        show_desc: true,
      },"img":require('@/assets/EcologicalRecruitment/banner1.png')}}),_c('isCom'),_c('isFooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }